import React from 'react'
import styles from "./Skeleton.module.css";

export default function Skeleton() {

    const Spinner = () => (
        <svg
            width="18" height="18" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" strokeWidth="2.5"
            className={styles.spinner}
        >
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
        </svg>
    );
    return (
        <div className={styles.skeletonContainer}>
            <Spinner />
        </div>
    )
}
